import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Consolas', 'Courier New', monospace;
  }

  /* Accessibility: focus-visible instead of removing all outlines */
  *:focus {
    outline: none;
  }

  *:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }

  a:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }

  .non-selectable {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }

  html, body {
    width: 100%;
    height: 100%;
    scroll-behavior: smooth;
  }

  /* Respect reduced motion preference */
  @media (prefers-reduced-motion: reduce) {
    html {
      scroll-behavior: auto;
    }

    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }

  body {
    background-color: #1e1e1e;
    font-size: 16px;
    transition: background-color 0.3s ease;
    overflow-x: hidden;
    overflow-y: auto;
  }

  [id] {
    scroll-margin-top: 80px;
    scroll-behavior: smooth;
  }

  .app {
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    padding: 15px;
  }

  .app.classic-mode {
    display: block;
    padding: 0;
    margin: 0;
    width: 100%;
    height: auto;
    min-height: 100vh;
    overflow-x: hidden;
    overflow-y: visible;
    position: relative;
  }

  /* Theme body classes (backward compatible) */
  body.cmd-theme {
    background-color: #0C0C0C !important;
    background-image: linear-gradient(to bottom, #0C0C0C, #0C0C0C) !important;
    color: #CCCCCC !important;
  }

  body.powershell-theme {
    background-color: #012456;
    background-image: linear-gradient(to bottom, #012456, #012456);
  }

  body.ubuntu-theme {
    background-color: #300A24;
    background-image: linear-gradient(to bottom, #300A24, #300A24);
  }

  /* Mobile */
  @media (max-width: 768px) {
    .app {
      padding: 10px;
      padding-top: 60px;
    }

    html, body {
      height: 100%;
    }
  }

  @media (max-width: 480px) {
    .app {
      padding: 5px;
      padding-top: 60px;
    }

    body {
      font-size: 14px;
    }
  }

  /* Animation utility classes */
  .fade-in {
    animation: fadeIn 0.3s ease forwards;
  }

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  .scale-in {
    animation: scaleIn 0.3s ease forwards;
  }

  @keyframes scaleIn {
    from { transform: scale(0.9); opacity: 0; }
    to { transform: scale(1); opacity: 1; }
  }
`;

export default GlobalStyles;
